// English translations for the customs-shipment area, keyed by the Russian source string.
export default {
  // Table columns / labels
  'Код': 'Code',
  'Вес': 'Weight',
  'Цена': 'Price',
  'Получатель': 'Recipient',
  'Номер телефона получателя': 'Recipient phone number',
  'Статус риска': 'Risk status',
  'Действие': 'Action',
  'Дата': 'Date',
  'Филиал': 'Branch',
  'Адрес филиала': 'Branch address',
  'Количество посылок': 'Number of parcels',
  'Общий вес посылок': 'Total parcel weight',
  'Общее количество партий': 'Total number of batches',
  'Общая сумма': 'Total amount',
  'Тип': 'Type',
  'Статус': 'Status',
  'Название': 'Name',
  'Описание': 'Description',
  // Yes / No
  'Да': 'Yes',
  'Нет': 'No',
  // Shipment types
  'Воздух': 'Air',
  'Земля': 'Ground',
  'Экспресс': 'Express',
  'Контейнер': 'Container',
  // Buttons / actions
  'Добавить': 'Add',
  'Добавить посылку': 'Add parcel',
  'Добавить отправление': 'Add shipment',
  'Зарегистрировать': 'Register',
  'Сохранить': 'Save',
  'Изменить': 'Change',
  'Изменить статус': 'Change status',
  'Убрать': 'Remove',
  'Отмена': 'Cancel',
  'Просмотр': 'View',
  'Убрать посылку': 'Remove parcel',
  'Убрать отправление': 'Remove shipment',
  'Новое отправление': 'New shipment',
  'Отметить как доставленное': 'Mark as delivered',
  // Search / placeholders
  'Поиск': 'Search',
  'Код, отправитель, получатель': 'Code, sender, recipient',
  'Комментарий к удостоверению личности': 'ID document comment',
  // Empty states
  'Нет данных': 'No data',
  // Validation messages
  'Введите название!': 'Enter a name!',
  'Введите дату!': 'Enter a date!',
  'Введите тип!': 'Enter a type!',
  'Введите статус!': 'Enter a status!',
  'Выберите филиал!': 'Select a branch!',
  // Confirmation dialogs
  'Убрать посылку!': 'Remove parcel!',
  'Вы собираетесь убрать посылку из таможенных данных. Продолжить?': 'You are about to remove the parcel from the customs data. Continue?',
  'Убрать отправление!': 'Remove shipment!',
  'Вы собираетесь убрать отправление из таможенных данных. Продолжить?': 'You are about to remove the shipment from the customs data. Continue?',
  // Notifications
  'Успешно сохранено': 'Successfully saved',
  'Произошла ошибка': 'An error occurred',
  'Посылка успешно убрана': 'Parcel successfully removed',
  'Отправление успешно убрано': 'Shipment successfully removed',
  'Статус успешно изменён': 'Status changed successfully',
}
